<div class="sidebar-container">
  <ng-content></ng-content>
</div>
